(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initLazyVideos() {
      var videos = document.querySelectorAll('.hero__lazy-video');
      videos.forEach(function(video) {
        video.preload = 'auto';
        video.addEventListener('canplay', function onCanPlay() {
          video.play().then(function() {
            video.classList.add('is-playing');
          }).catch(function() {});
          video.removeEventListener('canplay', onCanPlay);
        }, { once: true });
        video.load();
      });
    }

    if (document.readyState === 'complete') {
      setTimeout(initLazyVideos, 1500);
    } else {
      window.addEventListener('load', function() {
        setTimeout(initLazyVideos, 1500);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
